// Lite Vin — nivåskala, vinbrickor och tider för bordsbokning.
// Uppdatera värdena här när något ändras.

export type LevelGroupId = 'gott' | 'extra' | 'sjukt'

export type WineLevel = {
  letter: string
  name: string
  signal: string
  full: number
  half: number
  group: LevelGroupId
}

// Lite Vin-skalan — F är mest lättillgänglig, AA*** mest sällsynt.
export const WINE_LEVELS: WineLevel[] = [
  { letter: 'F', name: 'Fair', signal: 'Friskt, lättdrucket, okomplicerat', full: 109, half: 65, group: 'gott' },
  { letter: 'E', name: 'Easy', signal: 'Enkelt att tycka om, avslappnat', full: 119, half: 70, group: 'gott' },
  { letter: 'D', name: 'Distinct', signal: 'Mer personlighet och tydligare karaktär', full: 129, half: 75, group: 'gott' },
  { letter: 'C', name: 'Complex', signal: 'Mer lager, djup och komplexitet', full: 139, half: 80, group: 'gott' },
  { letter: 'B', name: 'Balanced', signal: 'Välbalanserat och genomarbetat', full: 149, half: 85, group: 'gott' },
  { letter: 'A', name: 'Artful', signal: 'Mer precision och hantverk', full: 159, half: 90, group: 'extra' },
  { letter: 'A+', name: 'Adventurous', signal: 'Mer originellt och spännande', full: 169, half: 95, group: 'extra' },
  { letter: 'A++', name: 'Arresting', signal: 'Viner som verkligen fångar uppmärksamheten', full: 179, half: 100, group: 'extra' },
  { letter: 'A+++', name: 'Ambitious', signal: 'Hög ambitionsnivå och tydlig kvalitet', full: 189, half: 105, group: 'extra' },
  { letter: 'AA*', name: 'Astonishing', signal: 'Exceptionellt och minnesvärt', full: 199, half: 110, group: 'extra' },
  { letter: 'AA**', name: 'Absolutely Rare', signal: 'Ovanliga, begränsade och svåra att hitta', full: 219, half: 120, group: 'sjukt' },
  { letter: 'AA***', name: 'Almost Impossible', signal: 'Extremt sällsynta / unika', full: 249, half: 135, group: 'sjukt' },
]

export const LEVEL_GROUPS: {
  id: LevelGroupId
  title: string
  range: string
  note?: string
}[] = [
  { id: 'gott', title: 'Något Gott', range: 'F–B' },
  { id: 'extra', title: 'Något Extra', range: 'A–AA*' },
  {
    id: 'sjukt',
    title: 'Något Sjukt',
    range: 'AA**–AA***',
    note: 'Begränsat · byts ut ofta',
  },
]

export type WineFlight = {
  id: 'gott' | 'extra'
  name: string
  count: string
  servings: string
  price: number
  priceLabel: string
  description: string
  level: string
  cta: string
}

export const WINE_FLIGHTS: WineFlight[] = [
  {
    id: 'gott',
    name: 'Något Gott',
    count: '5 viner',
    servings: 'Ca 8–10 cl per vin',
    price: 499,
    priceLabel: '499 kr',
    description:
      'Våra lättare och mest lättillgängliga viner. Friskt, enkelt, personligt och riktigt gott.',
    level: 'F–B',
    cta: 'Välj Något Gott',
  },
  {
    id: 'extra',
    name: 'Något Extra',
    count: '5 viner',
    servings: 'Ca 8–10 cl per vin',
    price: 649,
    priceLabel: '649 kr',
    description:
      'Lite mer djup, personlighet och wow. Viner med mer precision, karaktär och överraskningar.',
    level: 'A–AA*',
    cta: 'Välj Något Extra',
  },
]

export const WINE_ADDON = {
  name: 'Något Sjukt',
  count: '2 viner',
  servings: 'Ca 8–10 cl per vin',
  price: 299,
  priceLabel: '+299 kr',
  description:
    'För de riktigt nyfikna. Extremt ovanliga och unika viner som vi bara har inne i begränsad mängd.',
  level: 'AA**–AA***',
  label: 'Begränsat · byts ut ofta',
  cta: 'Lägg till',
}

// Bokningsbara tider — uppdatera efter era vinkvällar.
export const RESERVATION_TIMES = [
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
]

export const WINE_PHOTOS = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/fc57e600-0f66-4d91-ab8a-0b7d7035bade.jpg',
  glasses:
    'https://cdn.magicpatterns.com/patterns/generated-images/009a578e-5e64-441e-8815-78573ed3d2d4.jpg',
  board:
    'https://cdn.magicpatterns.com/patterns/generated-images/9c70efb4-f1c0-4c38-aff6-981b9dd338f7.jpg',
  pour: 'https://cdn.magicpatterns.com/patterns/generated-images/11c5c3f8-3afa-4621-bcef-df59aabc1036.jpg',
}
